import { gql, TypedDocumentNode } from "@apollo/client";

import { Query, Mutation } from "types/generated";

type GetApiKeysManageableByNonHumansData = Pick<Query, "apiKeysManageableByNonHumans">;

export const GET_API_KEYS_MANAGEABLE_BY_NON_HUMANS: TypedDocumentNode<GetApiKeysManageableByNonHumansData> = gql`
  query GetApiKeysManageableByNonHumans {
    apiKeysManageableByNonHumans
  }
`;

type ToggleApiKeyManagementFromNonHumansData = Pick<
  Mutation,
  "accountToggleAPIKeyManagementFromNonHumans"
>;

export const TOGGLE_API_KEYS_MANAGEABLE_BY_NON_HUMANS: TypedDocumentNode<ToggleApiKeyManagementFromNonHumansData> = gql`
  mutation ToggleAPIKeyManagementFromNonHumans {
    accountToggleAPIKeyManagementFromNonHumans
  }
`;
